const cssStyle = `

.main-content {
    background: #f8f8f8;
    margin-top: 100px;
    padding-top: 20px;
}
.row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
.col-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}
.col-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
}
.col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
}

.col-lg-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
}
.col-lg-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.666667%;
    flex: 0 0 33.666667%;
    max-width: 33.666667%;
}
.col-lg-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 26.333333%;
    flex: 0 0 26.333333%;
    max-width: 26.333333%;
}

.no-margin {
    margin-left: 0;
    margin-right: 0;
}

.no-padding {
    padding-left: 0;
    padding-right: 0;
}

.w200{
  width:100px;
}
.w300{
  width:200px;
}
.table-title-content {
    background: #F9FAFA;
    padding: 0;
    border: 1px solid #CECECE;
    margin-bottom:20px;
}
.table-title h2 {
    font-weight: 600;
    font-size: 1.2rem;
    letter-spacing: 1.33px;
    padding: 0 0 15px;
    margin: 0;
    color: #3a687d;
}

.sub-title {
    color: #366887;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 1.17px;
    padding: 10px 0;
    margin-bottom:0px;
}
.summary-content {
    padding-bottom: 30px;
    background: #fff;
    padding: 0px;
}
.content-section-left {
  float: left;
  display: inline-block;
  border-left: 0.5px solid #cecece;
  padding: 0 16px;
  margin: 10px 0;
}
.content-section-left:first-child {
  border-left: 0.5px solid transparent;
}
.content-section-right {
  float: right;
  display: inline-block;
  text-align: right;
  background: #fff;
  padding: 10px 15px;
}

.content-list .primary-text {
  font-size: 1.0rem;
}
.content-list .bold {
  font-weight: 600;
}
.content-list-title {
  font-size: 8px;
  color: #404040;
}
.content-list .action {
  cursor: pointer;
  color: #376f99;
  font-weight: bold;
  font-size: 1.0rem;
}

.summary-action {
    width: calc(100% - 630px);
    text-align: right;
}
.new .table {
  border: 1px solid #CECECE;
  /*Radio-btn*/
  /*checkbox*/
}
.new .table-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding: 5px 0;
  width: 100%;
  border: 1px solid #fff;
  border-top: 0;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  margin: 0px;
}
.new .table-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto;
  border: transparent;
  background-color: transparent;
}
.new .table-header .table-th {
  float: left;
  color: #005399;
  font-size: 8px;
  padding: 4px 6px;
  font-weight: 700;
  letter-spacing: 0.8px;
}
.new .table-td {
  float: left;
  color: #404040;
  font-size: 8px;
  padding: 4px 6px;
  font-weight: 600;
  line-height: 22px;
  box-shadow: none;
  background-color: transparent;
}
.new .table-td a {
  color: #376f99;
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
}
.new .table .table-rowbg {
  margin: 0px;
}
.new .table .table-rowbg:nth-of-type(odd) {
  background-color: #fff;
}
.new .table .table-rowbg:nth-of-type(even) {
  background-color: #e9ecec;
}
.new .table .focus-contain-div {
  position: absolute;
  margin-left: 0px;
  min-width: 100px;
  margin-top: 0px;
  z-index: 2;
}
.new .table .el-radio + .el-radio {
  margin-left: 0;
}
.new .table .el-radio__label {
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  padding-left: 0;
}
.new .table .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
.new .table .el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background: #fdfdfd;
}
.new .table .el-radio__input.is-checked .el-radio__inner::after {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: #0086ff;
}
.new .table .el-checkbox + .el-checkbox {
  margin-left: 0;
}
.new .table .el-checkbox__label {
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  padding-left: 0;
}

.panel-header-right ul, .panel-grid-list, .panel-body-header-right ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.panel {
  display: flow-root;
  border: 1px solid #dee5e6;
  padding: 0;
  margin-bottom: 20px;
}
.panel-header {
  border-bottom: 1px solid #e8e8e8;
  display: flow-root;
  padding: 6px 10px;
}
.panel-header-left {
  color: #234357;
  font-size: 1.6rem;
  font-weight: 600;
  letter-spacing: 1.33px;
  float: left;
}
.panel-header-right {
  float: right;
}
.panel-header-right ul {
  line-height: 19px;
}
.panel-header-right ul li {
  display: inline-block;
  padding: 0 10px;
  color: #376f99;
  font-size: 1.2rem;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
}
.panel-grid {
  display: flow-root;
}
.panel-grid-list {
  border-bottom: 1px solid #e8e8e8;
  display: flow-root;
}
.panel-grid-list .text-value {
  margin: 7px 10px !important;
  color: #404040;
  border-bottom: 1px solid #dee5e6;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 22px;
  border-top: 1px solid transparent;
  border-right: 1px solid transparent;
  border-left: 1px solid transparent;
  outline: none;
}
.panel-grid-list .text-inputvalue {
  margin: 7px 10px !important;
  color: #404040;
  border-bottom: 1px solid transparent;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 22px;
  border-top: 1px solid transparent;
  border-right: 1px solid transparent;
  border-left: 1px solid transparent;
  outline: none;
}
.panel-grid-list-text {
  margin: 7px 10px !important;
  color: #234357;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 22px;
}
.panel-grid-list-active {
  padding: 10px 15px;
  text-align: center;
  color: #376f99;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.2rem;
  text-decoration: none;
  cursor: pointer;
}
.panel-grid-list li {
  float: left;
  padding: 10px 0 0;
  min-width: 180px;
  border-right: 1px solid #e8e8e8;
  height: 60px;
}
.panel-grid-list-header {
  text-transform: uppercase;
  padding-left: 10px;
  color: #6e6e6e;
  font-size: 1rem;
}
.panel-body-header {
  border-bottom: 1px solid #e8e8e8;
  display: flow-root;
  padding: 6px 10px;
}
.panel-body-header-left {
  color: #234357;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 1.33px;
  float: left;
  line-height: 19px;
}
.panel-body-header-right {
  float: right;
}
.panel-body-header-right ul {
  line-height: 19px;
}
.panel-body-header-right ul li {
  display: inline-block;
  padding: 0 10px;
  color: #376f99;
  font-size: 1.2rem;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
}
.panel-table-header {
  padding: 10px;
  border-bottom: 1px solid #e8e8e8;
}
.panel-table-header .col-th {
  color: #404040;
  font-weight: normal;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.83px;
  display: inline-block;
}
.panel-table-body-tr {
  padding: 8.35px 10px;
}
.panel-table-body-tr:nth-child(odd) {
  background-color: #f9fafa;
}
.panel-table-body .col-td {
  color: #404040;
  font-weight: 600;
  font-size: 1.2rem;
  display: inline-block;
  letter-spacing: 0.83px;
}
.panel-footer {
  display: flow-root;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 10px solid #f8f8f8;
  box-shadow: 0 -4px 7px 0 rgba(215, 215, 215, 0.4);
  width: calc(100% - 40px);
  margin-left: auto;
  margin-right: auto;
  background: #fff;
}
.panel-footer-row {
  background-color: #fff;
  margin-left: 20px;
  margin-right: 0;
}
.panel-footer-title {
  color: #404040;
  font-size: 1.8rem;
  font-weight: normal;
  letter-spacing: 0.45px;
  padding: 16px 20px 0 0;
  margin: 0;
}
.panel-footer .panel-grid-list {
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid transparent;
  display: flow-root;
  border-left: 1px solid #e8e8e8;
  float: right;
}
.panel-footer .panel-grid-list li {
  height: 50px;
}
.panel-footer .panel-grid-list .dropdown-section .el-select .el-input__inner {
  height: 30px;
}
.panel-footer .panel-grid-list .dropdown-section .select-text {
  color: #404040;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0px 10px;
  margin: 6px 0;
  text-transform: uppercase;
}
.panel-footer .panel-grid-list .dropdown-section .text-value {
  margin: 5px 10px !important;
  line-height: 12px;
}
.panel-footer .panel-grid-list .dropdown-section .text-value input {
  border: 1px solid transparent;
  outline: none;
  font-weight: 600;
  font-size: 1.2rem;
}
.panel-footer .panel-grid-list .dropdown-section .text-value input:focus {
  outline: none;
}


.summary-panel {
  background-color: #fff;
}
.summary-panel .panel-grid-list {
  border-bottom: 1px solid transparent;
}
.summary-panel .panel-grid-list li {
  border-bottom: 1px solid #f6f6f6;
  border-top: 1px solid #f6f6f6;
}
.summary-panel .panel-grid-list li:first-child {
  border-left: 1px solid #f6f6f6;
}
.summary-panel .panel-grid-right {
  float: right;
  text-align: right;
  border-right: 1px solid transparent;
}


.signature-field {
  position: relative;
}
.signature-field textarea {
  border: 1px solid #e8e8e8;
  outline: none;
  text-align: center;
  padding: 7% 0 0;
}
.signature-content {
  padding: 10px 0;
}
.signature-content .content-list {
  line-height: 26px;
}
.signature-content .content-list-title {
  font-weight: 600;
}
.signature-content .content-list-label {
  color: #404040;
  font-size: 1.4rem;
}
.signature-content .content-list-total {
  font-size: 1.4rem;
  font-weight: bold;
  letter-spacing: 0.35px;
  text-align: right;
}
.signature-totalcontent {
  padding: 20px;
}
.signature-totalcontent .content-list {
  line-height: 30px;
}
.signature-totalcontent .content-list-title {
  font-weight: 600;
  font-size:1.0rem;
}
.signature-totalcontent .content-list-label {
  color: #404040;
  font-size: 1.0rem;
  padding-left: 10px;
}
.signature-totalcontent .content-list-label.mrg10 {
  margin-left: -10px;
  padding-right: 0;
}
.signature-totalcontent .content-list-label .nmrg10 {
  margin-left: 10px;
  margin-right: 12px;
}
.signature-totalcontent .content-list-label input {
  border-bottom: 0.5px solid #979797;
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  outline: none;
  font-size: 1.2rem;
  width: 50%;
  background: transparent;
}
.signature-totalcontent .content-list-label .dropdown-section .el-select input {
  width: 100%;
}
.signature-totalcontent .content-list-label .dropdown-section .el-select .el-input.is-focus .el-input__inner {
  background: transparent;
  box-shadow: none;
}
.signature-totalcontent .content-list-label .dropdown-section .el-select .el-input .el-select__caret {
  font-size: 12px;
  font-weight: bolder;
}
.signature-totalcontent .content-list-label .dropdown-section .el-select .el-input__inner {
  background: transparent;
}
.signature-totalcontent .content-list-label ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #404040;
  font-size: 1.2rem;
  font-style: italic;
  font-weight: normal;
  opacity: 0.7;
}
.signature-totalcontent .content-list-label ::-moz-placeholder {
  /* Firefox 19+ */
  color: #404040;
  font-size: 1.2rem;
  font-style: italic;
  font-weight: normal;
}
.signature-totalcontent .content-list-label :-ms-input-placeholder {
  /* IE 10+ */
  color: #404040;
  font-size: 1.2rem;
  font-style: italic;
  font-weight: normal;
}
.signature-totalcontent .content-list-label :-moz-placeholder {
  /* Firefox 18- */
  color: #404040;
  font-size: 1.2rem;
  font-style: italic;
  font-weight: normal;
}
.signature-totalcontent .content-list-total {
  font-size: 1.0rem;
  font-weight: bold;
  letter-spacing: 0.35px;
  text-align: right;
}
.signature-totalcontent .content-list-total.error {
  color: #d0021b;
}
.signature-totalcontent .content-list-total.primary {
  color: #4a90e2;
}
.signature-totalcontent .content-list-notes {
  color: #404040;
  font-size: 1.2rem;
  letter-spacing: 0.3px;
  line-height: 15px;
  font-style: italic;
}
.signature-totalcontent .content-list.lh {
  line-height: 34px;
}
.signature-totalcontent .content-list .lhn {
  line-height: 24px;
}
.signature-totalcontent .content-list.hr {
  border-bottom: 0.5px solid #e8eef1;
  padding: 7px 0;
}
.pdfnone{
  display:none;
}
.bg-sign{
  background-color: rgba(239, 239, 239, 0.29);
  margin: 0px 0;
  width:100%;
}
.bottomfixed{
  font-size:8px;
  text-align: center;
  width: 100%;
}

.pdfheader{
  background: #234357;
  padding: 15px;
  border:1px solid #efefef;
  margin-bottom:20px;
  font-size:1.0rem;
  padding:10px 0px;
}
.invoiceleft{
  padding:0 10px;
}
.invoiceright{
  text-align:right;
  padding:0 10px;
}
`;

export default cssStyle;
